(function() {
  'use strict';

  function injectStyles() {
    if (document.getElementById('kaching-shine-styles')) return;
    var style = document.createElement('style');
    style.id = 'kaching-shine-styles';
    style.textContent = [
      '@keyframes kaching-shine {',
      '  0% { transform: translateX(-100%); }',
      '  100% { transform: translateX(100%); }',
      '}',
      '.kaching-bundles__bar-most-popular--simple {',
      '  overflow: hidden !important;',
      '}',
      '.kaching-bundles__bar-most-popular--simple::after {',
      '  position: absolute !important;',
      '  content: "" !important;',
      '  display: block !important;',
      '  top: 0 !important; left: 0 !important;',
      '  width: 100% !important; height: 100% !important;',
      '  z-index: 10 !important;',
      '  background: linear-gradient(',
      '    -45deg,',
      '    rgba(255,255,255,0) 40%,',
      '    rgba(255,255,255,0.5) 50%,',
      '    rgba(255,255,255,0) 60%',
      '  ) !important;',
      '  animation: kaching-shine 2.2s linear infinite !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function check() {
    if (document.querySelector('.kaching-bundles__bar-most-popular--simple')) {
      injectStyles();
      return true;
    }
    return false;
  }

  function init() {
    if (check()) return;

    var observer = new MutationObserver(function() {
      if (check()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback: para de observar tras 30s
    setTimeout(function() { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();